import React, { useEffect, useState } from "react";
import { API_START_POINT } from "../Component/AllApi";
import videoProgressIcon from "../Assets/Images/Dashboard/video_progress_icon.svg";
import { Pie, PieChart, Cell } from "recharts";
import videoCircle from "../Assets/Images/Dashboard/video_progress_circle.svg";
import performanceCircle from "../Assets/Images/Dashboard/assessment_icon.png";
import clockIcon from "../Assets/Images/Dashboard/clock_icon.svg";
import watchedVideoIcon from "../Assets/Images/Dashboard/watcher_videos.svg";
import remainingVideoIcon from "../Assets/Images/Dashboard/remaining_videos.svg";
import assessmentScoreIcon from "../Assets/Images/Dashboard/assessment_score.svg";

const TeacherVideoProgress = (props) => {
  // console.log('Teacher Video Progress props', props.trainer_id);

  const data = [
    { name: "Category A", value: 80 },
    { name: "Remaining", value: 20 },
  ];
  const [progessData, setProgressData] = useState([]);

  const token = localStorage.getItem("authToken");
  const selectedSection = localStorage.getItem("selectedSection");

  const TRAINER_VIDEO_PROGRESS =
    selectedSection === "Robotics"
      ? `${API_START_POINT}/dashboardData/trainer/${props.trainer_id}`
      : `${API_START_POINT}/drone-dashboardData/trainer/${props.trainer_id}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await fetch(TRAINER_VIDEO_PROGRESS, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          // console.log("data: ", data);
          setProgressData(data);
        }
      } catch (err) {
        console.error("Error occured ", err);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="videoProgress">
        <div className="row mb-0">
          <div className="col-lg-7">
            <div className="card progress_card ps-5">
              <div className="row">
                <div className="col-lg-7">
                  <img src={videoProgressIcon} alt="videoProgressIcon" />
                  <p className="progressTitle mt-3">Video Watching Progress</p>
                  <p className="allTimeTitle mt-3">All Time</p>
                  <p className="videosWatched mt-4">
                    <img src={videoCircle} alt="videoCircle" className="me-2" />
                    {/* <span style={{color:'black',padding:'6px'}}></span> */}
                    <span style={{ fontWeight: "700" }}>
                      {/* 65% */}
                      {progessData && progessData?.watched_percentage}%
                    </span>{" "}
                    Videos watched
                  </p>
                  <p className="assessmentCompleted mt-4">
                    <img
                      src={performanceCircle}
                      alt="performanceCircle"
                      className="me-2"
                    />
                    <span style={{ fontWeight: "700" }}>
                      {/* 55% */}
                      {progessData &&
                        progessData?.assessment_completion_percentage}
                      %
                    </span>{" "}
                    Assessment completed
                  </p>
                </div>
                <div className="col-lg-5">
                  <div>
                    <PieChart width={200} height={200}>
                      <Pie
                        // data={[
                        //   { name: "inner", value: 20 },
                        //   { name: "rest", value: 80 },
                        // ]}
                        data={[
                          {
                            name: "inner",
                            value: progessData?.watched_percentage,
                          },
                          {
                            name: "rest",
                            value: 100 - progessData?.watched_percentage,
                          },
                        ]}
                        cx="40%"
                        cy="50%"
                        innerRadius={70}
                        outerRadius={80}
                        fill="#4991BA"
                        stroke="none"
                      >
                        {data.map((entry, index) => (
                          <Cell
                            key={`inner-cell-${index}`}
                            fill={index === 0 ? "#EDB552" : "#4991BA"}
                          />
                        ))}
                      </Pie>

                      <Pie
                        // data={data}
                        data={[
                          {
                            name: "outer",
                            value:
                              progessData?.assessment_completion_percentage,
                          },
                          {
                            name: "rest",
                            value:
                              100 -
                              progessData?.assessment_completion_percentage,
                          },
                        ]}
                        dataKey="value"
                        nameKey="name"
                        cx="40%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={60}
                        fill="#4991BA"
                        stroke="none"
                        startAngle={90} // Adjust the start angle here
                        endAngle={-270}
                      >
                        {data.map((entry, index) => (
                          <Cell
                            key={`outer-cell-${index}`}
                            fill={index === 0 ? "#FB7F49" : "#4991BA"}
                          />
                        ))}
                      </Pie>

                      <text
                        x="40%"
                        y="50%"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill="#fff"
                        fontSize={12}
                      >
                        <tspan x="40%" dy="-1em">
                          Videos
                        </tspan>
                        <tspan x="40%" dy="1.2em">
                          vs
                        </tspan>
                        <tspan x="40%" dy="1.2em">
                          Assessment
                        </tspan>
                      </text>
                    </PieChart>
                  </div>
                </div>
              </div>
              <div className="totalWatchTimeCard mt-3">
                <span>
                  <img src={clockIcon} alt="clockIcon" className="me-2" />
                  Total Video watch time: {progessData?.total_watch_time}
                  {/* 32 : 04 */}
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="videoProgressCard card">
              <div className="d-flex">
                <img src={watchedVideoIcon} alt="watchedVideoIcon" />
                <div className="my-auto">
                  <p className="videoProgressTitle ms-3 mb-0">Watched Videos</p>
                  <span className="videoProgressNo ms-3">
                    {progessData?.watched_videos_count}
                  </span>
                </div>
              </div>
            </div>
            <div className="videoProgressCard mt-3 card">
              <div className="d-flex">
                <img src={remainingVideoIcon} alt="remainingVideoIcon" />
                <div className="my-auto">
                  <p className="videoProgressTitle ms-3 mb-0">
                    Remaining Videos
                  </p>
                  <span className="videoProgressNo ms-3">
                    {progessData?.remaining_videos_count}
                  </span>
                </div>
              </div>
            </div>
            <div className="videoProgressCard mt-3 card">
              <div className="d-flex">
                <img src={assessmentScoreIcon} alt="assessmentScoreIcon" />
                <div className="my-auto">
                  <p className="videoProgressTitle ms-3 mb-0">
                    Assessment Score
                  </p>
                  <span className="videoProgressNo ms-3">
                    {progessData?.average_assessment_score}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TeacherVideoProgress;
